import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { NewOAuthIntegrationItem } from "./../../../../Integrations"
import { generatePath, useNavigate } from "../../../../router-utils"

export default function NewOAuthIntegrationPage() {
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New OAuth App</title>
			</Helmet>
			<Breadcrumbs
				title="New OAuth App"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					["", "OAuth App"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="4xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewOAuthIntegrationItem
								onSuccess={({ integration, oauthClient }) =>
									navigate("/integrations/:integrationId/oauth/setup", {
										params: {
											integrationId: integration.uid,
										},
										state: oauthClient ? { oauth_client: oauthClient } : null,
										replace: true,
									})
								}
								onCancel={() =>
									navigate("/org/integrations", { replace: true })
								}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
